import { createSlice } from "@reduxjs/toolkit";

export const CategoryInitialState = {
  categories: [],
};

export const categorySlice = createSlice({
  name: "category",
  initialState: CategoryInitialState,
  reducers: {
    setCategories: (state, action) => {
      state.categories = action.payload.categories;
    },
  }
});

export const { setCategories } = categorySlice.actions;
